<script setup>

defineProps(['imgSrc', 'title', 'desc']);

</script>

<template>
  <div class="grid grid-cols-2 text-basecolor overflow-hidden md:px-14">
    <div class="rounded-2xl border-2 border-black">
      <img
        class="rounded-2xl w-full h-full object-cover"
        :src="imgSrc"
        alt="Course Preview image"
      >
    </div>
    <div class="rounded-2xl pl-4 pr-4 pb-4 py-6 overflow-hidden">
      <h3 class="text-sm font-bold leading-6">
        {{ title }}
      </h3>
      <p class="text-2xs mt-3">
        {{ desc }}
      </p>
    </div>
  </div>
</template>

<style scoped>

</style>
